module.exports = __webpack_public_path__ + "media/images/posts/why_choose_winter_wedding3-c34a3f789142b41f39963c35a51b2ff8.jpg";